import { lazy } from "react";
import type { RouteObject } from "react-router";
import { STAFF_AND_UP_ROLES } from "@/src/ai-assistant/constants/ai-assistant.constants";
import { AI_ASSISTANT_ROUTES } from "@/src/ai-assistant/constants/ai-assistant-routes.constants";
import { ProtectedRoute } from "@/src/auth/components/protected-route";

const AIChatPage = lazy(() => import("@/src/ai-assistant/pages/ai-chat.page"));

export const aiAssistantRoutes: RouteObject[] = [
	{
		element: <ProtectedRoute requiredRole={[...STAFF_AND_UP_ROLES]} />,
		children: [{ path: AI_ASSISTANT_ROUTES.chat, element: <AIChatPage /> }],
	},
];
